export const ActionTypes = {
  SWITCH_LANGUAGE_EN: "SWITCH_LANGUAGE_EN",
  SWITCH_LANGUAGE_TR: "SWITCH_LANGUAGE_TR",
  LOGIN_USER: "LOGIN_USER",
  LOGOUT_USER: "LOGOUT_USER",
  ACTIVATE_USER: "ACTIVATE_USER",
};
